/* @flow */

import {createSelector} from 'reselect';
import {getUIState} from '../ui-selectors';

const getTrialUIState = createSelector([getUIState], (uiState) => uiState.trial);

// $FlowFixMe upgrading Flow to v0.92.1 on web
export const getIsModalOpen = createSelector([getTrialUIState], (isModalOpen) => isModalOpen);
